import { createSelector } from 'reselect';
import { RootState } from '..';
import { SearchState } from '.';

const targetStateSelector: (state: RootState) => SearchState = (state) => state.search;

export const selectSearchTags = createSelector(targetStateSelector, (search) => search.searchTags);
